<script>
  import Button from '../components/Button.svelte';
  import PartnerLogoCard from '../components/PartnerLogoCard.svelte';
  import { partnersSection } from './partners.js';
</script>

<section id="partners" class="partners-section" aria-labelledby="partners-title">
  <div class="partners-bg" aria-hidden="true"></div>

  <div class="partners-inner">
    <div class="partners-content">
      <div class="partners-head">
        <div class="partners-copy">
          <div class="title-group">
            <h2 id="partners-title">
              {#each partnersSection.title as line}
                <span>{line}</span>
              {/each}
            </h2>
            <div class="section-line" aria-hidden="true"></div>
          </div>

          <p>{partnersSection.description}</p>
        </div>

        <div class="general-partner">
          <span>{partnersSection.generalLabel}</span>
          <PartnerLogoCard {...partnersSection.generalPartner} featured />
        </div>
      </div>

      <div class="partners-list">
        <div class="partners-grid">
          {#each partnersSection.partners as partner}
            <PartnerLogoCard {...partner} />
          {/each}
        </div>

        <a class="show-all" href={partnersSection.showAll.href}>
          <span>{partnersSection.showAll.label}</span>
          <span class="show-all-arrow" aria-hidden="true"></span>
        </a>
      </div>

      <div class="partner-cta">
        <img
          class="cta-mark"
          src="/icons/partners-icon-chart.svg"
          alt=""
          aria-hidden="true"
          loading="lazy"
        />

        <div class="cta-copy">
          <h3>{partnersSection.cta.title}</h3>
          <p>
            <img
              class="cta-check"
              src="/icons/partners-icon-check.svg"
              alt=""
              aria-hidden="true"
              loading="lazy"
            />
            <span>{partnersSection.cta.text}</span>
          </p>
        </div>

        <Button
          href={partnersSection.cta.action.href}
          label={partnersSection.cta.action.label}
          target={partnersSection.cta.action.target}
          rel={partnersSection.cta.action.rel}
          variant="primary"
        />
      </div>
    </div>
  </div>
</section>

<style>
  .partners-section {
    position: relative;
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding: 100px 0;
    background: #000000;
    color: #ffffff;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-variation-settings: 'wdth' 100;
  }

  .partners-bg {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
  }

  .partners-bg::before {
    display: none;
  }

  .partners-inner {
    position: relative;
    z-index: 1;
    display: flex;
    width: min(100%, 1440px);
    justify-content: center;
    padding: 0 64px;
    box-sizing: border-box;
  }

  .partners-content {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 80px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .partners-head {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 48px;
    align-items: flex-start;
    width: 100%;
  }

  .partners-copy {
    display: flex;
    width: 620px;
    flex-direction: column;
    gap: 32px;
  }

  .title-group {
    display: flex;
    flex-direction: column;
    gap: 21px;
    align-items: flex-start;
  }

  h2,
  h3,
  p {
    margin: 0;
  }

  h2 {
    color: #ffffff;
    font-size: 56px;
    font-weight: 700;
    line-height: 56px;
    text-transform: uppercase;
  }

  h2 span {
    display: block;
  }

  .section-line {
    width: 78px;
    height: 4px;
    background: #e7b962;
  }

  .partners-copy p {
    max-width: 620px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
  }

  .general-partner {
    display: flex;
    flex: 1 0 0;
    min-width: 420px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }

  .general-partner > span {
    color: #e7b962;
    font-size: 30px;
    font-weight: 400;
    line-height: normal;
    text-align: center;
    text-transform: uppercase;
  }

  .general-partner :global(.partner-logo-card) {
    width: 100%;
  }

  .partners-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
  }

  .partners-grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-auto-rows: 1fr;
    gap: 16px 24px;
  }

  .show-all {
    display: inline-flex;
    min-height: 44px;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 13px 23px;
    border-radius: 5px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    line-height: 18px;
    text-decoration: none;
    text-transform: uppercase;
  }

  .show-all:hover,
  .show-all:focus-visible {
    color: #e7b962;
    text-decoration: none;
  }

  /* Border-chevron вместо SVG-mask с rotate(90deg): на маленьких размерах
     приплющенный SVG визуально хуже border-стрелки (PR #134). Direction = down. */
  .show-all-arrow {
    width: 10px;
    height: 10px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: translateY(-25%) rotate(45deg);
  }

  .partner-cta {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 26px;
    padding: 24px 30px;
    border: 2px solid #ffa800;
    border-radius: 16px;
    background: rgba(0, 0, 0, 0.72);
    box-sizing: border-box;
  }

  .cta-mark {
    flex: 0 0 56px;
    width: 56px;
    height: 56px;
    object-fit: contain;
  }

  .cta-copy {
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    flex-direction: column;
    gap: 12px;
  }

  h3 {
    color: #ffffff;
    font-size: 24px;
    font-weight: 700;
    line-height: normal;
  }

  .cta-copy p {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
  }

  .cta-check {
    flex: 0 0 30px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }

  @media (max-width: 1279px) {
    .partners-section {
      padding: 100px 0;
    }

    .partners-bg::before {
      right: -42%;
      bottom: -1%;
      width: 118vw;
      height: 112%;
    }

    .partners-inner {
      padding: 0 32px;
    }

    .partners-content {
      gap: 80px;
      padding: 0 12px;
    }

    .partners-head {
      flex-direction: column;
      gap: 48px;
      align-items: center;
    }

    .partners-copy,
    .general-partner {
      width: 100%;
      min-width: 0;
    }

    .partners-copy p {
      max-width: 100%;
    }

    .partners-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 24px;
    }

    .partner-cta {
      flex-direction: column;
      align-items: flex-start;
    }

    .cta-mark {
      display: none;
    }

    h2 {
      font-size: 40px;
      line-height: 1.1;
    }
  }

  @media (max-width: 1599px) and (min-width: 1280px) {
    h2 {
      font-size: 48px;
      line-height: 1.1;
    }
  }

  @media (max-width: 767px) {
    .partners-section {
      padding: 40px 0;
    }

    .partners-bg::before {
      right: -78%;
      bottom: -4%;
      width: 178vw;
      height: 118%;
    }

    .partners-bg::after {
      right: 38%;
    }

    .partners-inner {
      padding: 0 24px;
    }

    .partners-content {
      gap: 24px;
      padding: 0;
    }

    .partners-head {
      gap: 48px;
    }

    .partners-copy {
      gap: 32px;
    }

    h2 {
      font-size: 32px;
      line-height: 32px;
    }

    .section-line {
      align-self: center;
    }

    .partners-copy p {
      font-size: 18px;
      line-height: normal;
    }

    .general-partner > span {
      font-size: 16px;
    }

    .partners-grid {
      gap: 14px 18px;
    }

    .show-all {
      padding-right: 0;
      padding-left: 0;
    }

    .partner-cta {
      gap: 26px;
      padding: 24px 22px;
    }

    h3 {
      font-size: 24px;
    }

    .cta-copy p {
      align-items: flex-start;
      font-size: 18px;
    }

    .partner-cta :global(.button) {
      width: 100%;
    }
  }
</style>
